import * as numeral from 'numeral';
import * as React from 'react';
import Context from '../../State/Context';
import { IUsageSelector } from '../../Types/Datasources';
import { ESourceType } from '../../Types/Model';
import Markdown from '../Markdown';
import SectionOther from '../SectionOther';
import TotalFooter from '../TotalFooter';
import UsageSelector from '../UsageSelector';

export default class LicensedWaterUse extends React.Component {
    public render() {
        return (
            <Context.Consumer>
                {({ messages, crops, userState, onAddCrop, onAddOtherCrop, onChangeCropName, onChangeCropValue, onChangeOtherCropName, onChangeOtherCropValue, onToggleOption }) => {
                    const { cropSelections: selections, otherCropSelections, enabledOptions } = userState;
                    const options = crops.map(item => item.name);
                    const usageSelectorData: IUsageSelector = {
                        onAdd: onAddCrop,
                        onAddOther: onAddOtherCrop,
                        onChangeName: (index: number, text: string) => onChangeCropName(index, text),
                        onChangeOtherName: (index: number, text: string) => onChangeOtherCropName(index, text),
                        onChangeOtherValue: (index: number, value: string|number) => onChangeOtherCropValue(index, value),
                        onChangeValue: (index: number, value: string|number) => onChangeCropValue(index, value),
                        options,
                        otherCropSelections,
                        selections,
                    };

                    const { 
                        title, 
                        description,
                        subheadingIrrigation,
                        labelTypeOfCrop,
                        labelHectaresIrrigated,
                        labelDescription,
                        labelTotalKilolitresPerAnnum,
                        headingTotal,
                        buttonAddAnotherCrop,
                        buttonAddAnotherOther,
                        labelOther,
                        tooltipIrrigation,
                        tooltipOtherCrop,
                     } = messages.page3;

                     const onToggleEnable = () => onToggleOption(ESourceType.OtherCrop, !isEnabled(ESourceType.OtherCrop));
                     const isEnabled = (type: ESourceType) => enabledOptions.indexOf(type) > -1;

                     const getTotal = () => {
                        const parseTotal = (prev: number, next: string) => prev + numeral(next).value();
                        const total = [
                            ...selections.map(item => item.total),
                            ...(isEnabled(ESourceType.OtherCrop) ? otherCropSelections.map(item => item.total) : []),
                        ]
                        .reduce(parseTotal, 0);
        
                        return numeral(total).format('0,0.00') + ' kL';
                    };

                    return (
                        <div>
                            <h2>{title}</h2>
                            <Markdown source={description}/>
                            <UsageSelector
                                title={subheadingIrrigation}
                                headers={[labelTypeOfCrop, labelHectaresIrrigated]}
                                defaultOption={{ id: '', label: buttonAddAnotherCrop, value: '' }}
                                {...usageSelectorData}
                                tooltip={tooltipIrrigation}
                            />
                            <hr className="gray"/>
                            <SectionOther
                                buttonAddText={buttonAddAnotherOther}
                                enabled={isEnabled(ESourceType.OtherCrop)}
                                headers={[labelDescription, labelTotalKilolitresPerAnnum]} 
                                labelOther={labelOther}
                                onToggleEnable={onToggleEnable}
                                {...usageSelectorData}
                                tooltip={tooltipOtherCrop}
                            />
                            <hr className="green"/>
                            <TotalFooter label={headingTotal} total={getTotal()} />
                        </div>
                    )
                }}
            </Context.Consumer>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Components/Pages/LicensedWaterUse.tsx